<template>
  <div
    class="home"
    v-show="visible"
  >
    <h5>绑定桥梁</h5>
    <a-form
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item
        class="ipt"
        label="真实姓名"
        required
      >
        <a-input
          disabled
          v-model:value="msg.realName"
          placeholder="请输入"
        >
        </a-input>
      </a-form-item>
      <!-- <a-form-item
        class="ipt"
        label="角色描述"
      >
        <a-textarea
          v-model:value="formState.remark"
          placeholder="请输入"
        ></a-textarea>
      </a-form-item> -->
      <a-form-item
        class="ipt"
        label="桥梁列表"
      >
        <a-tree
          checkable
          :tree-data="treeData"
          :checkedKeys="bridges"
          :replace-fields="replaceFields"
          @check="check"
        />
      </a-form-item>
      <a-form-item
        class="ipt a-btn"
        label="&nbsp;"
      >
        <!-- <a-button class="cancel">取消</a-button> -->
        <a-button
          class="confirm"
          @click="handleFinish"
        >确定</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
// @ is an alias to /src
import { addPush } from "@/api/warning/warning.js";

export default {
  name: "",
  data() {
    return {
      visible: true,
      labelCol: {
        span: 5,
        align: 'top'
      },
      wrapperCol: {
        span: 17
      },
      formState: {
        userName: '',
        bridges: '',
      },
      replaceFields: {
        key: 'id',
        title: 'name'
      },
      treeData: [],
      bridges: [],
      msg: {}
    }
  },
  props: ['bridgeTree'],
  updated() {
    this.treeData = this.bridgeTree
    console.log(this.treeData)
  },
  methods: {
    show(record) {
      this.visible = true
      this.msg = record
      if (record.bridges) {
        this.bridges = record.bridges.split(',')
        for (let i = 0; i < this.bridges.length; i++) {
          this.bridges[i] = Number(this.bridges[i])
        }
      } else {
        this.bridges = []
      }
    },
    hide() {
      this.visible = false
    },
    check(checkedKeys, e) {
      console.log(checkedKeys);
      this.bridges = checkedKeys
    },
    handleFinish() {
      let query = {
        boundType: 1,
        userId: this.msg.userId,
        serviceId: this.bridges
      }
      addPush(query).then(res => {
        if (res.code == 200) {
          this.$message.success('绑定成功');
          this.$emit('confirm')
        }
      }).catch(res => {
        console.log(res)
      });
    }
  }
};
</script>
<style scoped>
.ipt {
  text-align: left;
}
.ipt input {
  width: 236px;
  height: 36px;
  line-height: 36px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ipt textarea {
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ant-input[disabled] {
  color: #000;
}
</style>
